import axios from "axios";

const server_App_URl = "https://aicreditrepair.io/app/backend/";
//const server_App_URl ="https://e46e-223-178-209-67.ngrok-free.app"
//  const server_App_URl = "http://192.168.142.24:3002";
// const server_App_URl = "http://192.168.29.3:3002"

// const agent = new https.Agent({
//     rejectUnauthorized: false,
//     minVersion: 'TLSv1',
//   });

const apiClient = axios.create({
  baseURL: server_App_URl,
  headers: {
    Accept: "application/json",
  },
  // httpsAgent: agent 
});


apiClient.interceptors.request.use(
  (config) => {

    const token = localStorage.getItem('Token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;

    if (response && response.status === 401 && !config._retry) {
      config._retry = true;
      try {
        return apiClient(config);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
